<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="分批申请单号:" prop="deliveryNum">
        <el-input v-model="searchForm.deliveryNum" placeholder="请输入分批单号" />
      </el-form-item>
      <el-form-item label="项目名称:" prop="masterProjectName" clearable>
        <el-input v-model.trim="searchForm.masterProjectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="masterContractNum">
        <el-input v-model="searchForm.masterContractNum" placeholder="请输入合同编号" @blur="searchForm.masterContractNum = (searchForm.masterContractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="发货单号:" prop="invoiceNum">
        <el-input v-model="searchForm.invoiceNum" placeholder="请输入发货单号" />
      </el-form-item>
      <el-form-item label="代理商名称:" prop="createByName">
        <el-input v-model="searchForm.createByName" placeholder="请输入代理商名称" />
      </el-form-item>
      <el-form-item label="部门:" prop="departmentName">
        <el-input v-model="searchForm.departmentName" placeholder="请输入部门" />
      </el-form-item>
      <el-form-item label="区域:" prop="regionName">
        <el-input v-model="searchForm.regionName" placeholder="请选择区域" />
      </el-form-item>
      <el-form-item label="现销/赊销:" prop="saleModesName">
        <el-select v-model="searchForm.saleModesCode" placeholder="请选择" clearable>
          <el-option v-for="option in salesTypeList" :key="option.name" :label="option.name" :value="option.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间:" prop="applyBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchTime.applyBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchTime.applyEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="Loading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>

      <div v-loading="tableLoading" class="tableBody">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="projectName" label="分批申请单号" align="left" min-width="90" fixed="left">
            <template v-slot="{row}">
              <el-button type="text" @click="goToPartialContractDetail(row)">
                {{ row.deliveryNum }}
              </el-button>
            </template>
          </el-table-column>

          <el-table-column prop="masterProjectName" label="项目名称" align="left" min-width="140" fixed="left">
            <template v-slot="{row}">
              <el-button type="text" class="el-btn-text-left" @click="goToMasterContractDetail(row)">
                {{ row.masterProjectName }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="masterContractNum" label="合同编号" align="left" width="130" />

          <el-table-column prop="createByName" label="代理商名称" align="left" width="130" />

          <el-table-column prop="contractType" label="订单分类" align="left" width="120" />

          <el-table-column prop="processStateDesc" label="分批发货状态" align="left" width="100" />

          <el-table-column prop="submitTime" label="申请时间" align="left" width="90" />

          <el-table-column prop="saleModesName" label="现销/赊销" align="left" width="80" />
          <el-table-column prop="amountSum" label="发货金额" align="right" width="120" header-align="left" />

          <el-table-column prop="assignRatio" label="已分配金额/比例" align="right" width="130" header-align="left">
            <template v-slot="{row}">
              {{ row.assignAll }}/{{ row.assignRatio }}%
            </template>
          </el-table-column>
          <!-- <el-table-column prop="processState" label="状态" align="left" width="100">
            <template v-solt="{row}">
              {{ row.processState }}
            </template>
          </el-table-column> -->
          <el-table-column prop="proportion" label="发货单号" align="left" width="">
            <template v-slot="{row}">
              <el-button type="text" @click="deliverClick(row)">
                {{ row.invoiceNum }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="proportion" label="物流单号" align="left" fixed="right">
            <template v-slot="{row}">
              <el-button type="text" @click="logistClick(row)">
                {{ row.logisticsNum }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
      </div>
    </el-form>
    <partShipCheck :id="partId" :dialog-form-visible="dialogFormVisible" @on-status-dialog="updataDialogFormVisible" />
    <deliverGoodsNumber :dialog-form-visible-deliver="dialogFormVisibleDeliver" :form="formNum" @on-status-dialog="updataDialogFormVisibleDeliver" />
    <logisticsNumber :dialog-form-visible-logist="dialogFormVisibleLogist" :form="formNum" @on-status-dialog="updataDialogFormVisibleLogist" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { selectPartialContractForAssistant } from '@/API';
import partShipCheck from '../partShipCheck';
import deliverGoodsNumber from '../partShipCheck/deliverGoodsNumber';
import logisticsNumber from '../partShipCheck/logisticsNumber';
export default {
  data () {
    return {
      // 定义组件
      dialogFormVisible: false,
      dialogFormVisibleDeliver: false,
      dialogFormVisibleLogist: false,
      formNum: {},
      partId: '',
      searchTime: {
        applyBeginTime: '',
        applyEndTime: ''
      },
      searchForm: {
        deliveryNum: '',
        masterContractNum: '',
        masterProjectName: '',
        createByName: '',
        departmentName: '',
        regionName: '',
        submitTime: '',
        saleModesCode: '',
        invoiceNum: ''
      },
      tableLoading: false,
      tableData: [
      ],
      Loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchTime.applyBeginTime) {
            let date = new Date(this.searchTime.applyBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      }
    };
  },
  components: {
    partShipCheck,
    deliverGoodsNumber,
    logisticsNumber
  },
  computed: {
    ...mapState({
      salesTypeList: state => state.enumeration.salesTypeList //  现销/赊销
    })
  },
  methods: {
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchTime.applyBeginTime = '';
      this.searchTime.applyEndTime = '';
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange () {
      this.doSearch();
    },
    goToPartialContractDetail (row) {
      this.partId = row.partialId;
      this.dialogFormVisible = true;
    },
    goToMasterContractDetail (row) {
      this.$router.push({ name: 'ContractInfo', params: { contractNum: row.masterContractNum }, query: { id: row.masterContractId, masterProjectName: row.masterProjectName } });
    },
    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    // 组件事件
    updataDialogFormVisibleDeliver (val) {
      this.dialogFormVisibleDeliver = val;
    },
    // 组件事件
    updataDialogFormVisibleLogist (val) {
      this.dialogFormVisibleLogist = val;
    },
    deliverClick (row) {
      this.formNum = row;
      this.dialogFormVisibleDeliver = true;
    },
    logistClick (row) {
      this.formNum = row;
      this.dialogFormVisibleLogist = true;
    },
    doSearch () {
      this.tableLoading = true;
      // 设置当前时间
      this.searchForm.submitTime = this.searchTime.applyBeginTime.replace(/-/g, '') + '-' + this.searchTime.applyEndTime.replace(/-/g, '');
      selectPartialContractForAssistant({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>

<style>

</style>
